<template>
  <div class="" v-if="isPropertyLoading || isTrainingProgramLoading"><Loading /></div>

  <div v-else>
    <BethsLayout :headline="`${property?.name} Training`">
      <div v-if="property?.isTrainingEnabled" class="flex flex-col justify-center p-16">
        <h1 class="text-3xl text-center">
          Congratulations {{ user?.firstName }}, you have finished the
          {{ trainingProgram?.name }} training!
        </h1>
        <div class="flex gap-4 justify-center text-center">
          <form action="/certificate/pdf" method="post" class="inline-block">
            <input
              type="hidden"
              name="userName"
              :value="user?.firstName + ' ' + user?.lastName"
            />
            <input type="hidden" name="propertyName" :value="property?.name" />
            <input
              type="hidden"
              name="trainingProgramName"
              :value="trainingProgram?.name"
            />
            <button
              v-if="
                trainingProgram?.trainingModules
                  ?.filter((m) => m.isActive)
                  .every((m) =>
                    completedModules.find(
                      (cm) => cm.trainingModuleId === m.trainingModuleId
                    )
                  ) // Every module should be completed
              "
              class="p-2 mt-4 text-md bg-blue-100 border rounded-md hover:bg-blue-200 inline-block"
              type="submit"
            >
              View Certificate
            </button>
          </form>
          <button
            v-if="property?.showExitButtonAtEndOfModule"
            class="mt-4 p-2 text-md bg-blue-100 border rounded-md hover:bg-blue-200 inline-block"
            @click="exitTraining"
          >
            Exit to Training Select
          </button>
        </div>
      </div>
      <div v-else>
        <h1>Training Not Enabled</h1>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useTrainingStore } from "../store/trainingStore";
import { useUserStore } from "../store/userStore";

const bldgStore = useBldgStore();
const trainingStore = useTrainingStore();
const userStore = useUserStore();
const route = useRoute();
const router = useRouter();

var isTrainingProgramLoading = ref(true);
var isPropertyLoading = computed(() => bldgStore.isLoading);
var trainingProgram = computed(() => trainingStore.selectedTrainingProgram);
var property = computed(() => bldgStore.property);
var user = computed(() => userStore.user);

var completedModules = computed(() =>
  (trainingProgram.value?.trainingModules ?? []).filter(
    (m) =>
      m.isActive &&
      user.value?.results?.find(
        (r) =>
          r.trainingModuleId == m.trainingModuleId && r.isPassingScore && !r.isExpired
      )
  )
);

onMounted(loadData);
watch(property, loadData);
watch(route.params, loadData);
async function loadData() {
  isTrainingProgramLoading.value = true;
  await userStore.getUser(property.value?.siteCode!, property.value?.portalId!, true);

  if (route.params.programId && typeof route.params.programId === "string") {
    let trainingProgramId = Number.parseInt(route.params.programId);
    await trainingStore.getTrainingProgram(trainingProgramId);
  }
  isTrainingProgramLoading.value = false;
}

function exitTraining() {
  router.push(`../`);
}
</script>
